import Header from "./Components/Header";
import Footer from "./Components/Footer";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import api from "../../api";
import {IndividualRecipeData} from "../types/Page";
import '../../styles/Recipe.scss'
import {IMAGE_URL} from "../../path";
import difficulty from '../../assets/images/difficulty.svg';
import minutes from '../../assets/images/minutes.svg';

function IndividualRecipe() {
    const {slug} = useParams();
    const navigate = useNavigate();
    const [recipeData, setRecipeData] = useState<IndividualRecipeData | null>(null);
    const [selectedSection, setSelectedSection] = useState("ingredients");

    async function fetchRecipe() {
        try {
            const res = await api.get(`/v1/recipe/${slug}`);
            setRecipeData(res.data);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        fetchRecipe();
    }, [slug])

    return (
        <div>
            <Header />
            <div className="individual-recipe">
                {recipeData && recipeData.recipe && (
                    <div>
                        <div className="individual-recipe-inner">
                            <div className="individual-recipe-inner-info">
                                <h2 className="recipe-category"><strong>Category: </strong>{recipeData.recipe.category.name}</h2>
                                <h1 className="recipe-title">{recipeData.recipe.name}</h1>
                                <div className="recipe-details">
                                    <div className="recipe-detail-inner">
                                        <div className="intro">prep</div>
                                        <div className="details">{recipeData.recipe.prep_time}</div>
                                    </div>
                                    <div className="recipe-detail-inner">
                                        <div className="intro">COOK</div>
                                        <div className="details">{recipeData.recipe.cook_time}</div>
                                    </div>
                                    <div className="recipe-detail-inner">
                                        <div className="intro">SERVES</div>
                                        <div className="details">{recipeData.recipe.serves}</div>
                                    </div>
                                    <div className="recipe-detail-inner">
                                        <div className="intro">RANGE</div>
                                        <div className="details">{recipeData.recipe.product?.range.name}</div>
                                    </div>
                                </div>
                                <p className="recipe-description">{recipeData.recipe.subtitle}</p>
                            </div>

                            <div className="individual-recipe-inner-image">
                                <div className="main-recipe-image">
                                    <img src={`${IMAGE_URL}/${recipeData.recipe.preview_image}`} alt={recipeData.recipe.name} />
                                </div>
                                <div className="main-recipe-product"
                                     style={
                                         {
                                             "--product-background-color":
                                             recipeData.recipe.product?.color_code,
                                         } as React.CSSProperties
                                     }>
                                    <img src={`${IMAGE_URL}/${recipeData.recipe.product?.sizes[0].pack_shot}`} />
                                    <div className={"recipe-main-product-info"}>
                                        <h2>{recipeData.recipe.product?.name}</h2>
                                        <h3>{recipeData.recipe.product?.sizes[0].title} ({recipeData.recipe.product?.sizes[0].capacity})</h3>
                                        <button onClick={() => navigate(`/product/${recipeData?.recipe.product?.slug}`)}>
                                            +
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="individual-recipe-steps">
                            <div className="individual-recipe-steps-top">
                                <div
                                    className={`individual-recipe-step ${
                                        selectedSection === "ingredients" ? "active" : ""
                                    }`}
                                    onClick={() => setSelectedSection("ingredients")}
                                >
                                    Ingredients <span>{selectedSection === "ingredients" ? "-" : "+"}</span>
                                </div>
                                <div
                                    className={`individual-recipe-step ${
                                        selectedSection === "method" ? "active" : ""
                                    }`}
                                    onClick={() => setSelectedSection("method")}
                                >
                                    Method <span>{selectedSection === "method" ? "-" : "+"}</span>
                                </div>
                            </div>
                            <div className="recipe-details">
                                <h3 className="need">{selectedSection === "ingredients" ? "What You'll Need": "What You'll Do"}</h3>
                                <h2 className="head">{selectedSection === "ingredients" ? "The Ingredients": "The Method"}</h2>

                                <div className={selectedSection === "ingredients" ? "ingredients-inner" : "method-inner"}>
                                    {selectedSection === "method" ? (
                                        <div dangerouslySetInnerHTML={{ __html: recipeData.recipe.method }} />
                                    ) : (
                                        recipeData.recipe.ingredient_sections.map((item, i) => (
                                            <div className="ingredient-item" key={i}>
                                                <h4>{item.component_name}</h4>
                                                <div className="divider"/>
                                                <div dangerouslySetInnerHTML={{__html: item.ingredients}} />
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="related">
                            <div className="related-head">

                                <div className="text">
                                    You May also like these
                                </div>
                            </div>
                            <div className="related-recipes">
                                <div className="related-recipes-grid">
                                    {recipeData.related_recipes.map((item, i) => (
                                        <div className="related-recipe-card" key={i}>
                                            <div className="related-recipe-image">
                                                <img
                                                    src={`${IMAGE_URL}/${item.preview_image}`}
                                                    alt={item.name}
                                                />
                                            </div>

                                            {item.category.icon && (
                                                <div className="related-recipe-icon">
                                                    <img
                                                        src={`${IMAGE_URL}/${item.category.icon}`}
                                                        alt={item.category.name}
                                                    />
                                                </div>
                                            )}

                                            <div className="related-recipe-info">
                                                <div className="recipe-read-time">
                                                    {/*{recipe.read_time} min read*/}
                                                    <div className="item">
                                                        <img src={minutes} alt="Minutes" />
                                                        <div className="time">{item.overall_time}</div>
                                                    </div>
                                                    <div className="item">
                                                        <img src={difficulty} alt="Difficulty" />
                                                        <div className="time">{item.difficulty}</div>
                                                    </div>

                                                </div>
                                                <h3>{item.name}</h3>
                                                <p>{item.preview_body}</p>
                                                <NavLink
                                                    to={`/recipe/${item.slug}`}
                                                    className="recipe-read-more"
                                                >
                                                    Read More
                                                </NavLink>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    )
}

export default IndividualRecipe;
